import axios from "axios";
import { API_URL } from "../config";
import WebApp from "@twa-dev/sdk";

export const requestInvoiceLink = async (userId, channel, APIKey) => {
  const response = await axios.get(
    `${API_URL}/api/payment/createInvoiceLink/${userId}`,
    {
      params: {
        initData: WebApp.initData,
        gems: channel.gems || 0,
        tickets: channel.tickets || 0,
        stars: channel.stars,
        itemId: channel.itemId,
        channelId: channel.itemId || channel.minerLevel ? undefined : channel._id,
        minerLevel: channel.minerLevel || 0,
      },
      headers: { "x-api-key": APIKey },
    }
  );
  const { orderId, invoiceLink } = response.data;
  return { invoiceLink, orderId };
};

export const checkPaymentStatusWithRetry = async (userId, orderId, APIKey, maxRetries = 5, delay = 2000) => {
  for (let attempt = 0; attempt < maxRetries; attempt++) {
    try {
      const res = await axios.get(
        `${API_URL}/api/payment/check/${userId}/${orderId}`,
        { 
          params: { timestamp: Date.now(), initData: WebApp.initData },
          headers: { "x-api-key": APIKey } 
        }
      );
      if (res.data === true) return true;
    } catch (e) {}
    await new Promise((resolve) => setTimeout(resolve, delay));
  }
  return false;
};
